
import {createContext, useState} from 'react'

const Context = createContext()

export const FlujosEstructureContextProvider = ({children}) => {
 const [allFlujosEstructure, setAllFlujosEstructure] = useState([])
 const [flujosEstructure, setFlujosEstructure] = useState([]);
 const [flujoEstructure, setFlujoEstructure] = useState({})
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })


 return <Context.Provider value={{allFlujosEstructure, setAllFlujosEstructure, flujosEstructure, setFlujosEstructure, flujoEstructure, setFlujoEstructure, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context